import { render } from "./Employee.vue?vue&type=template&id=315dbd6f&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"

import "./Employee.vue?vue&type=style&index=0&id=315dbd6f&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315dbd6f"]])

export default __exports__